import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  );
};

const initializeAuth = async () => {
  try {
    await msalInstance.initialize();
    const response = await msalInstance.handleRedirectPromise();

    if (response) {
      msalInstance.setActiveAccount(response.account);
      localStorage.setItem("authTokens", JSON.stringify({
        access: response.accessToken,
        account: response.account,
      }));
      window.location.href = "/projects";
      return;
    }
  } catch (error) {
    console.error("Redirect handling failed", error);
  }

  renderApp();
};

initializeAuth();
